"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ContactSalesButton = _interopRequireDefault(require("ui-addon-upgrades/_core/contactSales/ContactSalesButton"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _connectUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData"));

var CONTACT_SALES_BUTTON = _sources.sourceKeys.CONTACT_SALES_BUTTON;

var _default = (0, _connectUpgradeData.default)(_ContactSalesButton.default, CONTACT_SALES_BUTTON);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/button/UIContactSalesButton.js
// module id = 281
// module chunks = 5 6